import { keysToSnakeCase } from "./casing";

function appendFormData(formData: FormData, data: any, parentKey = ""): void {
  if (data === null || data === undefined) return;

  if (typeof data === "object" && !(data instanceof File)) {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      const newKey = parentKey ? `${parentKey}[${key}]` : key;
      appendFormData(formData, value, newKey);
    });
  } else {
    const valueToAppend = typeof data === "boolean" ? (data ? "1" : "0") : data;
    formData.append(parentKey, valueToAppend);
  }
}

export const toFormData = (obj: any): FormData => {
  const formData = new FormData();

  const objConverted = keysToSnakeCase(obj);

  for (let key in objConverted) {
    switch (objConverted[key]) {
      // formdata does not support boolean values
      case true:
        appendFormData(formData, "1", key);
        break;
      case false:
        appendFormData(formData, "0", key);
        break;
      default:
        appendFormData(formData, objConverted[key], key);
    }
  }

  return formData;
};
